var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-table',{ref:"table",attrs:{"url":"/api/v1/dialog/waiting-dialogs","attributes":[
      {
        attribute: 'ins_for_moderator.user',
        name: 'Letzter Moderator',
        type: 'UserNoEmailCell',
        sortable: false
      },
      {
        attribute: 'customer',
        name: 'Mitglied',
        type: _vm.customerCell,
        sortable: false
      },
      {
        attribute: 'fake',
        name: 'Fake',
        type: 'LinkProfileCell',
        sortable: false
      },
      {
        attribute: 'dialog_id',
        name: 'Dialog',
        type: 'DialogInfoCell',
        sortable: false
      },
      {
        attribute: 'last_message_at',
        name: 'In Warteschlange seit',
        type: 'TimeCounterCell'
      },
      {
        name: 'Aktionen',
        type: 'WaitingDialogActionCell'
      }
    ]},on:{"table-fetched":_vm.tableFetched}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n      Warteschlange der Nachrichten\n    ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }